var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticketID != null)?_c('div',[_c('iframe',{staticStyle:{"position":"absolute","height":"100%","border":"none"},attrs:{"src":_vm.serverUrl + '/storage/tickets/ticket_' + _vm.ticketID + '.pdf',"width":"100%","scrolling":"auto"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }